<mat-stepper #stepper (selectionChange)="matStepperSelectionChanged($event)">
  <!-- Header -->
  <mat-step [label]="config.headerTitle">
    <optsol-ngx-dynamic-form class="form" [fields]="config.dataImportFormJson.formFields"
      [fxLayout]="config.dataImportFormJson.fxLayout"
      [fxLayoutAlign]="config.dataImportFormJson.fxLayoutAlign"
      [fxLayoutGap]="config.dataImportFormJson.fxLayoutGap">
    </optsol-ngx-dynamic-form>
    <div>
      <button mat-button class="action-button" (click)="closeClicked()">Close</button>
      <button mat-button (click)="stepper.reset(); resetImportData();" class="action-button">Reset</button>
      <button mat-button (click)="formSubmitted(stepper)" [disabled]="!formValid" class="action-button">Next</button>
    </div>
  </mat-step>
  <!-- Details -->
  <mat-step [label]="config.linesTitle">
    <optsol-ngx-data-table *ngIf="tableConfig" [config]="tableConfig" [data]="tableData" [loading]="!tableData" [parentHeight]="tableHeight">
    </optsol-ngx-data-table>
    <button mat-button class="action-button" (click)="closeClicked()">Close</button>
    <button mat-button (click)="stepper.reset(); resetImportData();" class="action-button">Reset</button>
    <button mat-button matStepperPrevious class="action-button">Back</button>
    <button mat-button matStepperNext class="action-button">Next</button>
  </mat-step>
  <!-- Actions -->
  <mat-step [label]="config.actionsTitle">
    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="16px grid">
      <div *ngFor="let action of config.dataImportActions">
        <button mat-raised-button (click)="actionButtonClicked(action)">{{action.actionText}}</button>
      </div>
    </div>
    <div>
      <button mat-button class="action-button" (click)="closeClicked()">Close</button>
      <button mat-button (click)="stepper.reset(); resetImportData();" class="action-button">Reset</button>
      <button mat-button matStepperPrevious class="action-button">Back</button>
    </div>
  </mat-step>
</mat-stepper>